import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AccountsApiService } from "src/app/api/accounts-api.service";
import { CatalogApiService } from "src/app/api/catalog-api.service";
import { ProposalApiService } from "src/app/api/proposal-api.service";
import { ProposalRequest } from "src/app/model/order/order";
import { i18nService } from "src/app/service-utils/i18n.service";

@Injectable({
    providedIn: 'root'
  })
export class NewOrderProposalService {

    basic: number;

    constructor(private proposalApiService: ProposalApiService,
                private accountsApi: AccountsApiService,
                private catalogService: CatalogApiService,
                private i18nService: i18nService) {
    }

    public async buildCalculationRequest(proposalFirstSide: Array<FormGroup>, proposalSecondForm?: Array<FormGroup>): Promise<string> {
        let proposal: Array<ProposalRequest> = [];

        const basicData = await this.accountsApi.getBasicConfiguration().toPromise();
        (basicData.httpError.error.text === BIAS) ? this.basic = 1 : this.basic = 2;

        proposal.push(this.buildCalculationSide(proposalFirstSide, this.basic));
        if(proposalSecondForm) {
            proposal.push(this.buildCalculationSide(proposalSecondForm, this.basic));
        }

        return Promise.resolve(await this.proposalApiService.calculateProposal(proposal).toPromise());
    }

    private buildCalculationSide(proposalForm: Array<FormGroup>, basic: number): ProposalRequest {
        let proposalSide = new ProposalRequest();
        proposalSide.designType = basic;
        Object.keys(proposalForm[0].controls).forEach(key => {
            let value;
            if(proposalForm[0].get(key).disabled) {
                value = null;
            } else {
                value = this.i18nService.replaceFromCommaToDot(proposalForm[0].get(key).value.toString());
                //value = +proposalForm[0].get(key).value;
            }
            if(key === "hsa") {
                proposalSide.spectacularRefraction.vertexDistance = value;
            } else {
                if(value !== null) {
                    proposalSide.spectacularRefraction[key.charAt(0).toLowerCase() + key.slice(1)] = +value;
                }
            }
        });

        Object.keys(proposalForm[1].controls).forEach(key => {
            let value = proposalForm[1].get(key).value;
            if(key === "lensType") {
                proposalSide.cLType = (value === 'HARD') ? 1 : 2;
            } else if(key === "hhDia") {
                proposalSide.centralRadius.corneaDiamter = this.i18nService.replaceFromCommaToDot(proposalForm[1].get(key).value.toString());
                //proposalSide.centralRadius.corneaDiamter = +proposalForm[1].get(key).value;
            } else {
              proposalSide.centralRadius[key.charAt(0).toLowerCase() + key.slice(1)] = this.i18nService.replaceFromCommaToDot(proposalForm[1].get(key).value);
                //proposalSide.centralRadius[key.charAt(0).toLowerCase() + key.slice(1)] = +proposalForm[1].get(key).value;
            }
        });
        return proposalSide;
    }
}
const BIAS = "BIAS - BIAS-F";